import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'

import RecipeScheduler from './RecipeScheduler'
import featureToggles from '../../../featureToggles'
import { Collection } from '../../../types'
import { useUser } from '../../../pages/session/hooks'
import TaskCreator from './taskCreator'
import NoteForm from './NoteForm'
import POWERS from '../../../powers'
import InterviewForm from './InterviewForm'

type Tab = 'Note' | 'Task' | 'Email' | 'Recipe' | 'Interview'

interface Props {
  relatedCollection: Collection
  relatedId: string
  onSuccess(): Promise<any>
}

export default function FeedEditor(props: Props) {
  const { relatedId, relatedCollection, onSuccess } = props

  const [activeTab, setActiveTab] = useState<Tab>('Note')
  const user = useUser()

  return (
    <div className="relative z-[1000]">
      <Button.Group
        basic
        className="w-full overflow-x-auto [&::-webkit-scrollbar]:hidden"
      >
        <Button
          active={activeTab === 'Note'}
          onClick={() => setActiveTab('Note')}
        >
          <Icon name="bookmark outline" />
          Note
        </Button>
        <Button
          active={activeTab === 'Task'}
          onClick={() => setActiveTab('Task')}
        >
          <Icon name="tasks" /> Task
        </Button>
        {/* <Button
          active={activeTab === 'Email'}
          disabled
          onClick={() => setActiveTab('Email')}
        >
          <Icon name="mail outline" /> Email
        </Button> */}

        <Button
          active={activeTab === 'Interview'}
          onClick={() => setActiveTab('Interview')}
        >
          <Icon name="file alternate outline" /> Interview
        </Button>

        {featureToggles.recipes && (
          <Button
            active={activeTab === 'Recipe'}
            disabled={!user.hasPower(POWERS.runAndScheduleRecipes)}
            onClick={() => setActiveTab('Recipe')}
          >
            <Icon name="lab" /> Recipe
          </Button>
        )}
      </Button.Group>

      {activeTab === 'Note' && (
        <NoteForm
          relatedCollection={relatedCollection}
          relatedId={relatedId}
          onSuccess={onSuccess}
        />
      )}

      {activeTab === 'Task' && (
        <TaskCreator
          relatedCollection={relatedCollection}
          relatedId={relatedId}
          onSuccess={onSuccess}
        />
      )}

      {activeTab === 'Recipe' && (
        <div className="mt-6 border-b pb-6">
          <RecipeScheduler
            relatedCollection={relatedCollection}
            relatedId={relatedId}
            onSuccess={onSuccess}
          />
        </div>
      )}

      {activeTab === 'Interview' && (
        <InterviewForm
          relatedCollection={relatedCollection}
          relatedId={relatedId}
          onSuccess={onSuccess}
        />
      )}
    </div>
  )
}
